// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.setting-subtitle[data-v-27a11aef] {\n  color: #B8B8B8;\n  font-size: 16px;\n}\n.number--container[data-v-27a11aef] {\n  width: 240px;\n}\n", ""]);
// Exports
module.exports = exports;
